import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { LOCATION_LIST } from './url-constants';

type SiteLocationsEndpointSpecification = ApiEndpointSpecification;
export const SiteLocationsEndpointSpecification: SiteLocationsEndpointSpecification = {
    url: LOCATION_LIST,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SiteLocationsRequestParams',
    requestBodySchemaName: 'SiteLocationsRequestBody',
    okResponseSchemaName: 'SiteLocationsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSiteLocations = Helpers.makeApiRequestFn<
    Types.SiteLocationsRequestParams,
    Types.SiteLocationsRequestBody,
    Types.SiteLocationsOkResponse
>(SiteLocationsEndpointSpecification);
